import {styled} from "@mui/material/styles"

export const SEOLinkComponent = styled("a")`
    margin-top: 2rem;
    padding: 1rem 4rem;
    border: 1px solid black;
    color: black;
    display: block;
    list-style: none;
`
